import authService from '../../../api/authApi'
import {
  apiCallError,
  beginApiCall,
  endApiCall,
} from '../../../redux/actions/apiStatusActions'
import {
  signInSilentSuccess,
  signInSuccess,
  signOutSuccess,
} from '../../../redux/actions/identityActions'
import { useAppDispatch } from '../../../redux/configureStore'
import InteractiveSignInRequired from '../../../utils'

export const useIdentity = () => {
  const dispatch = useAppDispatch()
  const signIn = async () => {
    dispatch(beginApiCall())
    try {
      await authService.signIn()
      dispatch(signInSuccess())
    } catch (error) {
      dispatch(apiCallError())
      throw error
    }
  }

  const signOut = () => {
    dispatch(beginApiCall())
    try {
      authService.signOut()
      dispatch(signOutSuccess())
    } catch (error) {
      dispatch(apiCallError())
      throw error
    }
  }

  const signInSilent = async () => {
    try {
      dispatch(beginApiCall())
      const identity = await authService.getIdentity()
      dispatch(signInSilentSuccess(identity))
    } catch (error) {
      if (!(error instanceof InteractiveSignInRequired)) {
        dispatch(apiCallError())
      } else {
        dispatch(endApiCall())
      }
    }
  }

  return { signIn, signOut, signInSilent }
}
